import React from 'react';
import { Table, Input, Dropdown } from 'semantic-ui-react';


const Row = (props) => {
  const {
    data = {},
    rowIx,
    onChange,
    occupations,
    countries,
    counties
  } = props;

  return (
    <Table.Row>
      <Table.Cell>
        <Input
          required
          fluid
          rowix={rowIx}
          name='given_name'
          value={data['given_name']}
          onChange={onChange}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          required
          fluid
          rowix={rowIx}
          name='family_name'
          value={data['family_name']}
          onChange={onChange}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          required
          fluid
          rowix={rowIx}
          name='email'
          value={data['email']}
          onChange={onChange}
        />
      </Table.Cell>
      <Table.Cell>
         <Input
           required
           fluid
           rowix={rowIx}
           name='custom:year_of_birth'
           value={data['custom:year_of_birth']}
           onChange={onChange}
        />
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          required
          fluid
          search
          selection
          rowix={rowIx}
          name='custom:occupation'
          value={data['custom:occupation']}
          options= {occupations}
          onChange={onChange}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          fluid
          rowix={rowIx}
          name='custom:occupation_details'
          value={data['custom:occupation_details']}
          onChange={onChange}
        />
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          required
          fluid
          search
          selection
          rowix={rowIx}
          name='custom:country_of_residence'
          value={data['custom:country_of_residence']}
          options={countries}
          onChange={onChange}
        />
      </Table.Cell>
      <Table.Cell>
        {
          data['custom:country_of_residence'] === 'ee' &&
            <Dropdown
              fluid
              search
              selection
              required
              rowix={rowIx}
              name='custom:county_of_residence'
              value={data['custom:county_of_residence']}
              options={counties}
              onChange={onChange}
            />
        }
      </Table.Cell>
    </Table.Row>
  );
};

export default Row;



// WEBPACK FOOTER //
// ./src/private/common/components/Team/Form/Team/Members/Row.js